import { ReactComponent as SvgLoading } from '../Rolling-1s-200px.svg'

const Loading = () => {
	return (
		<div
			className="flex flex-col items-center justify-center bg-ci1/90 h-screen left-0 fixed top-0 w-screen z-20"
			style={{
				backgroundImage: `url(${process.env.PUBLIC_URL}/images/logos/logo-opacity.png)`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: '50% 50%',
				backgroundSize: 'contain'
			}}
		>
			<div>
				<SvgLoading className="h-20 w-20" />
			</div>
			<h2 className="text-white text-lg">Loading</h2>
		</div>
	)
}

export default Loading
